import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLineChart]'
})
export class LineChartDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/line/line.directive.ts